import { FeatureCollection, Geometry } from "geojson";
import { CustomSource } from "../models/CustomSource";
import { mapActive } from "../utils/map-utils";
import { OsaNode } from "../../osaway/models/OsaNode";

export class PendingCoordChangesMapSource {
  map: mapboxgl.Map;
  static sourceName = CustomSource.PendingCoordChanges;

  constructor(map: mapboxgl.Map) {
    this.map = map;

    this.config();
  }

  clear() {
    if (mapActive(this.map)) {
      try {
        this.map.removeLayer(lineLayerConfig.id);
        this.map.removeSource(sourceName);
      } catch (e) {
        console.warn("Error while removing layers and sources", e);
      }
    }
  }

  private config() {
    if (mapActive(this.map) && !this.map.getSource(sourceName)) {
      this.map.addSource(sourceName, sourceConfig);
      this.map.addLayer(lineLayerConfig);
    }
  }

  update(pendingCoordsByNodeId: Map<string, number[]>, nodes: OsaNode[]) {
    const geometries: Geometry[] = [];

    nodes.forEach((node) => {
      const matchedCoords = pendingCoordsByNodeId.get(node.id);
      if (matchedCoords) {
        geometries.push({
          type: "LineString",
          coordinates: [[node.longitude, node.latitude], matchedCoords],
        });
      }
    });

    this.updateGeoJson({
      ...defaultGeoJson,
      features: geometries.map((geometry) => ({
        type: "Feature",
        properties: {},
        geometry: geometry,
      })),
    });
  }

  private updateGeoJson(geoJson: FeatureCollection) {
    if (mapActive(this.map)) {
      const source = this.map.getSource(sourceName) as mapboxgl.GeoJSONSource;
      source?.setData(geoJson);
    }
  }

  reset() {
    this.updateGeoJson(defaultGeoJson);
  }
}

const defaultGeoJson: FeatureCollection = {
  type: "FeatureCollection",
  features: [],
};

const sourceName = PendingCoordChangesMapSource.sourceName;
const sourceConfig: mapboxgl.GeoJSONSourceSpecification = {
  type: "geojson",
  promoteId: "id",
  data: defaultGeoJson,
};

const lineLayerName = `${sourceName}-line`;
const lineLayerConfig: mapboxgl.LineLayerSpecification = {
  id: lineLayerName,
  source: sourceName,
  type: "line",
  layout: {
    "line-join": "round",
    "line-cap": "round",
  },
  paint: {
    "line-color": "#12D3C4",
    "line-width": 3,
    "line-dasharray": [2, 2],
  },
};
